import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const AcxSwitch = styled(Switch)({
    minWidth: "40px", // removing this results in container overflow bug
});

export default AcxSwitch;
